import type { OfferRequestEstimatedVolume } from '@houzy/schemas/offer-request-management';
import type {
    PartnerCockpitContactAttemptCount,
    PartnerCockpitReimbursementReason,
    PartnerCockpitReimbursementRequest,
    ReimbursementProofDocument,
} from '@houzy/schemas/partner-cockpit/reimbursement';

export const REIMBURSEMENT_STEP_IDS = ['terms', 'reason', 'details'] as const;
export type ReimbursementStepId = (typeof REIMBURSEMENT_STEP_IDS)[number];

export type ReimbursementStep = {
    id: ReimbursementStepId;
    labelKey: string;
};

// Every reason-specific field the form can collect, kept flat so the step can bind inputs without
// re-shaping the draft on each keystroke. `toReimbursementRequest` narrows it to what the chosen
// reason actually sends.
export type ReimbursementDraft = {
    termsAccepted: boolean;
    // Set once the request is accepted, so the flow keeps showing its confirmation even though the lead
    // has become ineligible by being requested.
    submitted: boolean;
    reason?: PartnerCockpitReimbursementReason;
    partnerFeedback: string;
    proofDocuments: ReimbursementProofDocument[];
    estimatedVolume?: Exclude<OfferRequestEstimatedVolume, 'InformationOnly'>;
    absenceFrom: string;
    absenceTo: string;
    contactedByPhone: boolean;
    contactedByEmail: boolean;
    contactedBySmsOrWhatsApp: boolean;
    numberOfTimesUserWasContacted?: PartnerCockpitContactAttemptCount;
};

export type ReimbursementRequest = PartnerCockpitReimbursementRequest;
